import React from 'react';

type Props = {
    className?: string;
};

// Architectural summary: Single source for the פעולות glyph shared by receipt tab + quick actions.
export const ItemActionsIcon: React.FC<Props> = ({ className }) => (
    <img src="/recieptactions.png" alt="" aria-hidden="true" className={className} />
);
